
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ListLayoutConfig, ListLayoutViewType } from '../core/list-layout.types';

@Component
export default class ListLayoutToolbar extends Vue {
    @Prop({ required: true }) config!: ListLayoutConfig;
    @Prop({ required: true }) activeView!: ListLayoutViewType;
    @Prop({ type: Boolean, default: false }) showFilters!: boolean;
    @Prop({ type: Boolean, default: false }) hasSelectedItems!: boolean;

    ViewType = ListLayoutViewType;
    selectedView: ListLayoutViewType = this.activeView;

    @Watch('activeView', { immediate: true })
    onActiveViewChange(newView: ListLayoutViewType) {
        this.selectedView = newView;
    }

    @Watch('selectedView')
    onSelectedViewChange(newView: ListLayoutViewType) {
        if (newView !== this.activeView) {
            this.$emit('view-change', newView);
        }
    }

    handleToggleFilters() {
        this.$emit('toggle-filters');
    }

    handleExport(format: 'xlsx' | 'csv' | 'pdf') {
        this.$emit('export', format);
    }
}
